import { ReactNode } from "react";
import { useNeumorphicTheme } from "@/contexts/NeumorphicThemeContext";
import { cn } from "@/lib/utils";
import { Link } from "react-router-dom";

interface NeumorphicNavButtonProps {
  to: string;
  children: ReactNode;
  isActive?: boolean;
  className?: string;
  onClick?: () => void;
  label?: string;
}

const NeumorphicNavButton = ({ 
  to,
  children, 
  isActive = false,
  className = "",
  onClick,
  label
}: NeumorphicNavButtonProps) => {
  let theme = "dark";
  try {
    const themeContext = useNeumorphicTheme();
    theme = themeContext.theme;
  } catch {
    // Not within NeumorphicThemeProvider, use default
  }

  const getStyles = () => {
    if (theme === "dark") {
      if (isActive) {
        return "bg-[#0a0a0a] shadow-[8px_8px_16px_#000000,inset_2px_2px_4px_#0d0d0d,inset_-2px_-2px_4px_#000000]";
      } else {
        return "bg-[#0a0a0a] shadow-[inset_12px_12px_24px_#000000,inset_-12px_-12px_24px_#0d0d0d]";
      }
    } else {
      if (isActive) {
        return "bg-[#f5f5f5] shadow-[12px_12px_24px_#c0c0c0,-12px_-12px_24px_#ffffff,inset_2px_2px_4px_#ffffff,inset_-2px_-2px_4px_#d0d0d0]";
      } else {
        return "bg-[#f0f0f0] shadow-[inset_12px_12px_24px_#c0c0c0,inset_-12px_-12px_24px_#ffffff]";
      }
    }
  };

  // Get short label from children or label prop
  const displayLabel = label || (typeof children === 'string' ? children : '');

  return (
    <Link
      to={to}
      onClick={onClick}
      className={cn(
        "w-[90px] h-[90px] rounded-full flex items-center justify-center transition-all duration-300 group relative flex-shrink-0",
        getStyles(),
        className
      )}
      title={typeof children === 'string' ? children : ''}
    >
      <span 
        className="text-[#E4683B] font-thin text-[15px] whitespace-nowrap transition-transform duration-200 group-hover:scale-105 text-center leading-tight"
      >
        {displayLabel}
      </span>
    </Link>
  );
};

export default NeumorphicNavButton;
